var chunkMapping = {
	"webpack_container_remote_playbook_Routes": [
		27843
	],
	"webpack_container_remote_sav_Routes": [
		83128
	]
};
var idToExternalAndNameMapping = {
	"27843": [
		"default",
		"./Routes",
		51959
	],
	"83128": [
		"default",
		"./Routes",
		28612
	]
};
var idToRemoteMap = {
	"27843": [
		{
			"externalType": "module",
			"name": ""
		}
	],
	"83128": [
		{
			"externalType": "module",
			"name": ""
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"27843": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 51959,
		"remoteName": ""
	},
	"83128": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 28612,
		"remoteName": ""
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}